var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMz = function SvgIconMz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m6.486 16.696-2.971 3.79A11.96 11.96 0 0 0 12 24c4.96 0 9.217-3.01 11.045-7.304z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M23.063 7.348C21.246 3.032 16.977 0 12 0a11.96 11.96 0 0 0-8.485 3.516L6.52 7.348z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.608 8.826v6.304h20.978c.27-.998.414-2.047.414-3.13 0-1.099-.148-2.163-.425-3.174z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M3.515 3.514c-4.687 4.686-4.687 12.285 0 16.97L12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m4.857 8.87.777 2.39h2.515L6.114 12.74l.777 2.391-2.034-1.478-2.034 1.478.777-2.391-2.035-1.478H4.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M7.131 12H2.583v2.086h4.548z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m7.993 9.607-.738-.738-2.398 2.398L2.46 8.869l-.738.738 2.4 2.396-2.4 2.4.738.727 2.397-2.393 2.398 2.393.738-.728-2.4-2.4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconMz;